<template>
  <base-tooltip
    v-show="error"
    :key="token"
    :shown="!!error"
    :token="token"
    :z-index="zIndex"
    :type="type"
    :triggers="errorTriggers"
    @click.native.prevent.stop>
    <error-icon />
    <template #content>
      {{ error }}
    </template>
  </base-tooltip>
</template>

<script>
import BaseTooltip from 'Components/ui/Tooltip/BaseTooltip.vue';
import ErrorIcon from 'Components/ui/Icons/ErrorIcon.vue';
import { uuidv4 } from 'Root/helpers/tools';

export default {
  name: 'ErrorTooltip',

  components: {
    BaseTooltip,
    ErrorIcon,
  },

  props: {
    error: {
      type: [String, Boolean],
      default: null,
    },

    errorTriggers: {
      type: Array,
      default: () => ['hover', 'focus'],
    },

    type: {
      type: String,
      default: 'error',
    },

    zIndex: {
      type: Number,
      default: 100,
    },
  },

  data() {
    return {
      token: uuidv4(),
    };
  },

  watch: {
    error(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.updateToken();
      }
    },
  },

  methods: {
    updateToken() {
      this.token = uuidv4();
    },
  },
};
</script>
